import axios from 'axios';
import { getAccessToken, setAccessToken } from './auth.util';
import { useEffect, useRef, useState } from 'react';
import { User } from '../types/user';
import { AuthenticationRequest } from '../requests/auth.request';
import { getCurrentCompanyId } from './token.util';

export const http = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

http.interceptors.request.use(config => {
  const token = getAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

http.interceptors.response.use(
  res => res,
  async err => {
    const original = err.config;

    if (err.response?.status === 401 && !original._retry) {
      original._retry = true;

      const { data } = await http.post('/api/refresh');
      setAccessToken(data.accessToken);

      original.headers.Authorization = `Bearer ${data.accessToken}`;
      return http(original);
    }

    return Promise.reject(err);
  },
);

http.interceptors.request.use(config => {
  const token = getAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;

  const companyId = getCurrentCompanyId();
  if (companyId) config.headers['x-company'] = companyId;
  return config;
});

export const useAuthInit = () => {
  const executed = useRef(false);

  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    if (executed.current) return;
    executed.current = true;

    const init = async () => {
      try {
        const res = await AuthenticationRequest.me();
        setUser(res);
      } catch {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    init();
  }, []);

  return { user, loading, setUser };
};
